import { Link } from "react-router-dom";

import { nvAgentDetailPath } from "@/components/navigator";
import { cn } from "@/lib/utils";
import type { DetailComparison } from "@/services/navigator/agent-detail-service";

import { DetailSection } from "./detail-parts";

// 유사 에이전트 비교 (설계서 slide 50 · Figma 03-01/03): 현재 제품 + 추천 최대 2개(열 수 유동), 행 7종 고정(값 없는 칸만 빈 칸), 이름 클릭 시 상세.
// 2차까지 · 수요자 / PwC 내부만 — 서버가 공급자 계정에는 이 섹션을 보내지 않아요(경쟁사 정보 노출 방지).
// 셀은 한 칸 최대 3줄까지 보여주고 넘치면 말줄임이에요.

export function ComparisonSection({ data }: { data: DetailComparison }) {
  const cols = data.agents.length;
  return (
    <DetailSection id="comparison" title="유사 에이전트 비교">
      <div className="overflow-x-auto">
        <div className="grid min-w-[760px] gap-x-3" style={{ gridTemplateColumns: `140px repeat(${cols}, minmax(0, 1fr))` }}>
          <div />
          {data.agents.map((a) => (
            <div key={a.id} className={cn("flex flex-col gap-[6px] px-[18px] pb-4 pt-[18px]", a.is_current ? "rounded-t-nv-card bg-nv-bg-page" : "")}>
              <span
                className={cn(
                  "inline-flex h-[23px] self-start items-center rounded-full px-[10px] text-[13px] leading-[21px]",
                  a.is_current ? "bg-nv-text-secondary text-white" : "bg-[#EDEDEA] text-nv-text-secondary",
                )}
              >
                {a.is_current ? "현재 보는 제품" : "추천"}
              </span>
              {a.is_current ? (
                <span className="text-[17px] font-medium leading-[27px] text-nv-text-primary">{a.name}</span>
              ) : (
                <Link to={nvAgentDetailPath(a.id)} state={{ source: "detail" }} className="text-[17px] font-medium leading-[27px] text-nv-text-primary hover:underline">
                  {a.name}
                </Link>
              )}
              {a.supplier_name && <span className="text-[13px] leading-[21px] text-nv-text-secondary">{a.supplier_name}</span>}
            </div>
          ))}
          {data.rows.map((row, r) => (
            <div key={row.label} className="contents">
              <div className="border-t border-nv-border py-[18px] pr-3 text-[13px] leading-[21px] text-nv-text-tertiary">{row.label}</div>
              {row.values.map((cell, c) => (
                <div
                  key={c}
                  className={cn(
                    "min-h-[104px] border-t border-nv-border px-[18px] py-[18px] text-[14px] leading-[22px]",
                    data.agents[c].is_current ? "bg-nv-bg-page text-nv-text-primary" : "text-nv-text-secondary",
                    data.agents[c].is_current && r === data.rows.length - 1 && "rounded-b-nv-card",
                  )}
                >
                  {cell.length > 0 && (
                    <div className="line-clamp-3 break-keep">
                      {cell.map((line, i) => (
                        <span key={i}>
                          {i > 0 && ", "}
                          {line}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </DetailSection>
  );
}
